export const notEmpty = <TValue>(value: TValue | null | undefined | ''): value is TValue => {
  return value !== null && value !== undefined && value != '';
};

export const getRandomItem = <T>(items: T[]): T => {
  return items[Math.round(Math.random() * (items.length - 1))];
};
